var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningOutlineIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57465 3.21684L1.51632 15.0002C1.37079 15.2522 1.29379 15.5379 1.29298 15.8289C1.29216 16.12 1.36756 16.4061 1.51167 16.6589C1.65579 16.9118 1.86359 17.1225 2.11441 17.27C2.36523 17.4176 2.65032 17.497 2.94132 17.5002H17.058C17.349 17.497 17.6341 17.4176 17.8849 17.27C18.1357 17.1225 18.3435 16.9118 18.4876 16.6589C18.6317 16.4061 18.7071 16.12 18.7063 15.8289C18.7055 15.5379 18.6285 15.2522 18.483 15.0002L11.4247 3.21684C11.2761 2.97193 11.0669 2.76944 10.8173 2.62891C10.5677 2.48838 10.2861 2.41455 9.99965 2.41455C9.71321 2.41455 9.43159 2.48838 9.18199 2.62891C8.93238 2.76944 8.72321 2.97193 8.57465 3.21684Z",
    stroke: "#92400E",
    strokeWidth: 1.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5V10.8333",
    stroke: "#92400E",
    strokeWidth: 1.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.1665H10.0083",
    stroke: "#92400E",
    strokeWidth: 1.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOutlineIcon);
export default __webpack_public_path__ + "static/media/warning_outline_icon.885bb4113e4c15ba95030ca40416f839.svg";
export { ForwardRef as ReactComponent };